import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import emptyAvatar from '@adsk/bim360-matrix-react-assets/icon-avatar-menu.svg';

import './_MentionSuggestionEntry.scss';

export default class MentionSuggestionEntry extends Component {
  renderAvatar(mention, theme) {
    if (mention.hasAvatar === true) {
      return (
        <img
          src={mention.avatar}
          className={theme.mentionSuggestionsEntryAvatar}
          role="presentation"
        />
      );
    } else if (mention.hasAvatar === false) {
      return (
        <div
          className={`MentionSuggestionEntry__missing-avatar ${
            theme.mentionSuggestionsEntryAvatar
          }`}
        >
          <SvgIcon width="14" height="16">
            {emptyAvatar}
          </SvgIcon>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      mention,
      theme,
      searchValue, // eslint-disable-line no-unused-vars
      isFocused, // eslint-disable-line no-unused-vars
      ...parentProps
    } = this.props;

    return (
      <div {...parentProps}>
        {this.renderAvatar(mention.toJS(), theme)}
        <div className={theme.mentionSuggestionsEntryText}>{mention.get('name')}</div>
      </div>
    );
  }
}

MentionSuggestionEntry.propTypes = {
  /**
   * The mention object to display for the current entry.
   */
  mention: PropTypes.object,
  /**
   * The theme object to know how to theme the current entry.
   */
  theme: PropTypes.object,
  /**
   * The search value of the current mention.
   */
  searchValue: PropTypes.string,
  isFocused: PropTypes.bool
};
